<template>
  <div class="pb-7">
    <template v-if="step >= 2">
      <div class="info-card border">
        <i class="ki-outline ki-car-2 fs-1"></i>
        <span class="ms-3 text-gray-700 parent-hover-primary fs-6 fw-bold">
        {{ vehicle.number }} <small class="text-gray-500 fw-normal" v-html="vehicle.passport"></small>
      </span>
        <span class="delete-item" @click="clearFrom">
        <i class="ki-outline ki-cross-square"></i>
      </span>
      </div>
    </template>
    <div v-else class="info-panel">
      <div class="row">
        <div v-if="fieldSettings.number.show || (isCreateVehicle() && fieldSettings.number.required)" class="col-6">
          <input-field
              v-model="vehicle.number"
              id="vehicle.number"
              name="vehicle_number"
              :disabled="fieldSettings.number.disabled && !isCreateVehicle()"
              :required="fieldSettings.number.required"
              @input="vehicle.number=$event.target.value.toUpperCase()"
              placeholder="Гос. номер авто"
              type="text"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.vin.show || (isCreateVehicle() && fieldSettings.vin.required)" class="col-6">
          <input-field
              v-model="vehicle.vin"
              id="vehicle.vin"
              name="vehicle_vin"
              :required="fieldSettings.vin.required"
              :disabled="fieldSettings.vin.disabled && !isCreateVehicle()"
              placeholder="VIN номер"
              @input="vehicle.vin=$event.target.value.toUpperCase()"
              type="text"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.type_id.show || (isCreateVehicle() && fieldSettings.type_id.required)" class="col-6">
          <select-field
              v-model="vehicle.type_id"
              id="vehicle.type_id"
              name="vehicle_type_id"
              :options="vehicleType"
              :required="fieldSettings.vin.required"
              :disabled="fieldSettings.vin.disabled && !isCreateVehicle()"
              placeholder="Тип"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.year.show || (isCreateVehicle() && fieldSettings.year.required)" class="col-6">
          <input-mask-field
              v-model="vehicle.year"
              id="vehicle.year"
              name="vehicle_year"
              :mask="['####']"
              :required="fieldSettings.year.required"
              :disabled="fieldSettings.year.disabled && !isCreateVehicle()"
              placeholder="Год выпуска"
              type="text"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.mark.show || (isCreateVehicle() && fieldSettings.mark.required)" class="col-6">
          <input-field
              v-model="vehicle.mark"
              id="vehicle.mark"
              name="vehicle_mark"
              :required="fieldSettings.mark.required"
              :disabled="fieldSettings.mark.disabled && !isCreateVehicle()"
              placeholder="Марка"
              type="text"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.model.show || (isCreateVehicle() && fieldSettings.model.required)" class="col-6">
          <input-field
              v-model="vehicle.model"
              id="vehicle.model"
              name="vehicle_model"
              :required="fieldSettings.model.required"
              :disabled="fieldSettings.model.disabled && !isCreateVehicle()"
              placeholder="Модель"
              type="text"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.color.show || (isCreateVehicle() && fieldSettings.color.required)" class="col-4">
          <input-field
              v-model="vehicle.color"
              id="vehicle.color"
              name="vehicle_color"
              :required="fieldSettings.color.required"
              :disabled="fieldSettings.color.disabled && !isCreateVehicle()"
              placeholder="Цвет"
              type="text"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.places.show || (isCreateVehicle() && fieldSettings.places.required)" class="col-4">
          <input-field
              v-model="vehicle.places"
              id="vehicle.places"
              name="vehicle_places"
              :required="fieldSettings.places.required"
              :disabled="fieldSettings.places.disabled && !isCreateVehicle()"
              placeholder="Количество мест"
              type="text"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.category.show || (isCreateVehicle() && fieldSettings.category.required)" class="col-4">
          <input-field
              v-model="vehicle.category"
              id="vehicle.category"
              name="vehicle_category"
              :required="fieldSettings.category.required"
              :disabled="fieldSettings.category.disabled && !isCreateVehicle()"
              placeholder="Категория"
              type="text"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.body.show || (isCreateVehicle() && fieldSettings.body.required)" class="col-6">
          <input-field
              v-model="vehicle.body"
              id="vehicle.body"
              name="vehicle_body"
              :required="fieldSettings.body.required"
              :disabled="fieldSettings.body.disabled && !isCreateVehicle()"
              placeholder="Номер кузова"
              type="text"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.chassis.show || (isCreateVehicle() && fieldSettings.chassis.required)" class="col-6">
          <input-field
              v-model="vehicle.chassis"
              id="vehicle.chassis"
              name="vehicle_chassis"
              :required="fieldSettings.chassis.required"
              :disabled="fieldSettings.chassis.disabled && !isCreateVehicle()"
              placeholder="Шасси"
              type="text"
              mb="5"
          />
        </div>
      </div>
      <div v-if="fieldSettings.engine.number.show || fieldSettings.engine.power.show || fieldSettings.engine.volume.show || isCreateVehicle()" class="text-gray-700 fw-bold mb-3 ms-2">Мотор</div>
      <div class="row">
        <div v-if="fieldSettings.engine.number.show || (isCreateVehicle() && fieldSettings.engine.number.required)" class="col-5">
          <input-field
              v-model="vehicle.engine.number"
              id="vehicle.engine.number"
              name="vehicle_engine_number"
              :required="fieldSettings.engine.number.required"
              :disabled="fieldSettings.engine.number.disabled && !isCreateVehicle()"
              placeholder="Номер"
              type="text"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.engine.power.show || (isCreateVehicle() && fieldSettings.engine.power.required)" class="col-4">
          <input-field
              v-model="vehicle.engine.power"
              id="vehicle.engine.power"
              name="vehicle_engine_power"
              :required="fieldSettings.engine.power.required"
              :disabled="fieldSettings.engine.power.disabled && !isCreateVehicle()"
              placeholder="Особые отметки"
              type="text"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.engine.volume.show || (isCreateVehicle() && fieldSettings.engine.volume.required)" class="col-3">
          <input-mask-field
              v-model="vehicle.engine.volume"
              id="vehicle.engine.volume"
              name="vehicle_engine_volume"
              :required="fieldSettings.engine.volume.required"
              :disabled="fieldSettings.engine.volume.disabled && !isCreateVehicle()"
              :mask="['####']"
              placeholder="Объем"
              type="text"
              mb="5"
          />
        </div>
      </div>
      <div v-if="fieldSettings.registration.number.show ||
                 fieldSettings.registration.certificate.show ||
                 fieldSettings.registration.date.show ||
                 fieldSettings.registration.region_id.show || isCreateVehicle()" class="text-gray-700 fw-bold mb-3 ms-2">Регистрация</div>
      <div class="row">
        <div v-if="fieldSettings.registration.certificate.show || (isCreateVehicle() && fieldSettings.registration.certificate.required)" class="col-6">
          <input-field
              v-model="vehicle.registration.certificate"
              id="vehicle.registration_certificate"
              name="vehicle_registration_certificate"
              :required="fieldSettings.registration.certificate.required"
              :disabled="fieldSettings.registration.certificate.disabled && !isCreateVehicle()"
              placeholder="Номер тех. паспорта"
              type="text"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.registration.date.show || (isCreateVehicle() && fieldSettings.registration.date.required)" class="col-6">
          <date-field
              v-model="vehicle.registration.date"
              id="vehicle.registration.date"
              name="vehicle_registration_date"
              :required="fieldSettings.registration.date.required"
              :disabled="fieldSettings.registration.date.disabled && !isCreateVehicle()"
              placeholder="Дата"
              mb="5"
          />
        </div>
        <div v-if="fieldSettings.registration.region_id.show || (isCreateVehicle() && fieldSettings.registration.region_id.required)" class="col-12">
          <select-field-from-model
              v-model="vehicle.registration.region_id"
              v-if="regions"
              id="vehicle.registration.region_id"
              name=vehicle.registration.region_id
              :required="fieldSettings.registration.region_id.required"
              :disabled="(fieldSettings.registration.region_id.disabled || productType == 3 || productType == 2)"
              :options="regions"
              placeholder="Регион"
              mb="5"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectFieldFromModel from "@/components/Fields/SelectFieldFromModel.vue";
import InputMaskField       from '@/components/Fields/InputMaskField.vue';
import SelectField          from "@/components/Fields/SelectField.vue";
import InputField           from '@/components/Fields/InputField.vue';
import DateField            from "@/components/Fields/DateField.vue";
import axios                from "axios";

export default {
  name: 'VehicleBpmData',
  props: {
    isClear: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    vehicleData: {
      type: Object,
      default: null
    },
    productType: {
      type: Number,
      default: 0
    },
    module: {
      typ: Function,
      required: true
    },
    mode: {
      type: [Object, Function],
      required: true
    }
  },
  components: {SelectFieldFromModel, DateField, SelectField, InputMaskField, InputField },
  emits: ['cancel', 'set-vehicle'],
  data () {
    return {
      fieldSettings: this.module.Vehicle.dataFieldsSettings(this.vehicle?.verify ?? true),
      vehicle: this.module.Vehicle.empty(),
      regions: null,
      step:    0,
      validFields:    true
    }
  },
  mounted() {
    this.getRegions()
  },
  computed: {
    vehicleType() {
      return {
        4:  'Легковые',
        5:  'Автобусы до 16 п.м',
        6:  'Грузовые',
        7:  'Троллейбусы, трамваи',
        8:  'Мототранспорт',
        10: 'Прицепы (полуприцепы)',
        11: 'Автобусы > 16 п.м',
        12: 'Воздушный',
        13: 'Морской',
        14: 'Железнодорожный',
        15: 'Спецтехника',
      }
    },
    verifyCategory() {
      return {
        0: 'Нерезидент',
        1: 'Резидент'
      }
    }
  },
  methods: {
    getRegions() {
      axios.get('/api/dictionaries/regions')
          .then(res => {
            this.regions = res.data
          })
    },
    clearFrom() {
      this.vehicle.passport = null
      this.vehicle.number   = null
      this.step             = 0
    },
    isCreateVehicle() {
      return false;
    },
    cancel() {
      this.$emit('cancel')
    },
  },
  watch: {
    vehicle: {
      deep: true,
      handler(newValue) {
        this.vehicle.registration.number = newValue.number
        this.validFields = this.module.Validator.areAllVehiclesRequiredFieldsFilled([newValue ?? {}], newValue.verify);
        if (this.module.Validator.simple(newValue)) {
          this.step = 1
        } else {
          this.step = 0
        }
      }
    },
    isClear: {
      deep: true,
      handler(val) {
        if (val) {
          this.clearFrom()
        }
      }
    },
    vehicleData: {
      immediate: true,
      handler(val) {
        if (val) {
          this.vehicle = val[0];
          this.fieldSettings = this.module.Vehicle.dataFieldsSettings(this.vehicle.verify);
        }
      }
    },
    productType: {
      immediate: true,
      handler(val) {
        switch (val) {
          case 1:
            if (this.productType === 1 && this.vehicle.verify === false) {
              this.vehicle.registration.region_id = 17
            }
            break;
          case 2:
            this.vehicle.registration.region_id = 17
            break;
          case 3:
            this.vehicle.registration.region_id = 18
            break;
        }
      }
    },
    'vehicle.verify': {
      immediate: true,
      handler(val) {
        this.fieldSettings = this.module.Vehicle.dataFieldsSettings(val);
      }
    },
    'vehicle.number': {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.vehicle.number = val.replaceAll(/[^\p{L}\p{N}]/gu, '');
          });
        }
      }
    },
    'vehicle.vin': {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.vehicle.vin = val.replaceAll(/[^\p{L}\p{N}]/gu, '');
          });
        }
      }
    }
  }
}
</script>

<style scoped>

</style>